import { render, staticRenderFns } from "./HelpCard.vue?vue&type=template&id=2cf3cdce&scoped=true"
import script from "./HelpCard.vue?vue&type=script&lang=js"
export * from "./HelpCard.vue?vue&type=script&lang=js"
import style0 from "./HelpCard.vue?vue&type=style&index=0&id=2cf3cdce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3cdce",
  null
  
)

export default component.exports